import { useEffect } from 'react';
import { useCookie } from 'react-use';
import dedent from 'ts-dedent';
import { NfaLoggerOptions } from '@nflx/cwa-helpers/dist/analytics/types';

const createNFALoggerOptions = (userId: string): NfaLoggerOptions => ({
  app: {
    name: 'production-technology-tools',
    version: '0.1.0',
  },
  user: {
    email: `${userId}@anonymous.netflix.com`,
    isInternal: false,
  },
});

/**
 * Component that initializes NFA logger for analytics.
 * Reads nflxUserId cookie set by the BFF and initializes the logger client-side.
 */
export const NfaLogger = () => {
  const [nflxUserId] = useCookie('nflxUserId');

  useEffect(() => {
    if (nflxUserId && typeof window !== 'undefined' && window._nfa) {
      const script = dedent`
        _nfa.initNfaLogger(${JSON.stringify(
          createNFALoggerOptions(nflxUserId)
        )})
      `;
      
      try {
        eval(script);
      } catch (error) {
        console.error('Failed to initialize NFA logger:', error);
      }
    }
  }, [nflxUserId]);

  return null;
};

